import React, { FC } from 'react';
import { connect } from 'react-redux';
import { getNCFileById } from '@reducers/manufacture';
import { updateHeaderConfig } from '@reducers/details';
import { getToolById } from '@reducers/clampingTools';
import DetailsPageWrapper from '@v2/pages/common/components/DetailsPageWrapper/DetailsPageWrapper';
import { useTitle } from '@v2/pages/common/hooks/useTitle';
import Links from '@components/ncFiles/components/links';
import { NCFileSearchItem } from '@interfaces/search';
import { ReducerEntityWithLoadingState } from '@v2/pages/common/interfaces';
import { useToolDetails } from '@v2/pages/common/hooks/useToolsDetails';

interface ToolsDetailsNCFileLinksProps {
  ncFileData: ReducerEntityWithLoadingState<NCFileSearchItem | null>;
}

const ToolsDetailsNCFileLinksComponent: FC<ToolsDetailsNCFileLinksProps> = ({ getToolById, updateHeaderConfig, getNCFileById, ncFileData }) => {
  const title = useTitle();

  useToolDetails({
    getToolById,
    updateHeaderConfig,
    getNCFileById,
    getFullNCFile: true,
  });

  return (
    <DetailsPageWrapper title={title.ncFile}>
      <Links isLoading={!ncFileData.wasLoaded} links={ncFileData?.data?.links ?? []} />
    </DetailsPageWrapper>
  );
};

const ToolsDetailsNCFileLinks = connect(({ details: { ncFileData } }) => ({ ncFileData }), {
  getToolById,
  updateHeaderConfig,
  getNCFileById,
})(ToolsDetailsNCFileLinksComponent);

export { ToolsDetailsNCFileLinks };
